/* Copyright (c) 2021 MOCA Systems, Inc.  All rights reserved. */

'use strict';
import * as angular from 'angular';
import { fancyFirebaseReferencer, fancyFirebaseGetters } from '@touchplan/fancy-referencer';
import firebase from 'firebase/compat/app';

angular
	.module('ticketspaceApp')
	// Remove $q
	.factory('firebaseIndices', [
		'fbConnection',
		function (fbConnection) {
			//returns array or projectId
			function projectAccess(projectId, userId) {
				const indicesUsersPath = fancyFirebaseGetters.getIndicesUsersPath(userId);
				if (projectId) {
					return fbConnection.loadObject(
						fancyFirebaseReferencer
							.getLegacyRef<firebase.database.Reference>(indicesUsersPath, projectId)
							.child(projectId)
					);
				} else {
					return fbConnection.loadArray(
						fancyFirebaseReferencer.getLegacyRef<firebase.database.Reference>(indicesUsersPath, projectId)
					);
				}
			}

			function setProjectAccess(projectId, userId) {
				const indicesUsersPath = fancyFirebaseGetters.getIndicesUsersPath(userId, projectId);
				let fb = fancyFirebaseReferencer.getLegacyRef<firebase.database.Reference>(
					indicesUsersPath,
					projectId
				);
				return fbConnection.set(fb, projectId);
			}
			function removeProjectAccess(projectId, userId) {
				const indicesUsersPath = fancyFirebaseGetters.getIndicesUsersPath(userId, projectId);
				let fb = fancyFirebaseReferencer.getLegacyRef<firebase.database.Reference>(
					indicesUsersPath,
					projectId
				);
				return fbConnection.remove(fb);
			}

			function projectMember(projectId, userId) {
				const indicesUsersPath = fancyFirebaseGetters.getIndicesUsersPath(userId, projectId);
				return fbConnection.loadObject(
					fancyFirebaseReferencer
						.getLegacyRef<firebase.database.Reference>(indicesUsersPath, projectId)
						.child('projectMemberId')
				);
			}

			//callback will be executed outside of the digest loop,
			//may or may not be an issue
			function setProjectMember(projectId, userId, pmId) {
				const indicesUsersPath = fancyFirebaseGetters.getIndicesUsersPath(userId, projectId);
				let fb = fancyFirebaseReferencer
					.getLegacyRef<firebase.database.Reference>(indicesUsersPath, projectId)
					.child('projectMemberId');
				return fbConnection.set(fb, pmId);
			}
			function removeProjectMember(projectId, userId) {
				const indicesUsersPath = fancyFirebaseGetters.getIndicesUsersPath(userId, projectId);
				let fb = fancyFirebaseReferencer
					.getLegacyRef<firebase.database.Reference>(indicesUsersPath, projectId)
					.child('projectMemberId');
				return fbConnection.remove(fb);
			}

			return {
				projectAccess,
				setProjectAccess,
				removeProjectAccess,
				projectMember,
				setProjectMember,
				removeProjectMember,
			};
		},
	]);
